import { render } from "./ExpandableCell.vue?vue&type=template&id=4fed2c5d&scoped=true&ts=true"
import script from "./ExpandableCell.vue?vue&type=script&lang=ts"
export * from "./ExpandableCell.vue?vue&type=script&lang=ts"

import "./ExpandableCell.vue?vue&type=style&index=0&id=4fed2c5d&lang=scss&scoped=true"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed2c5d"]])

export default __exports__